<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('nav.create-blog') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.website') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('nav.create-blog') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<el-form ref="form" :model="formData" size="large" :rules="formRules">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<h4>{{ $t('website.title1') }}</h4>
						</div>
						<div class="card-body">
							<el-row :gutter="20">
								<el-col :span="24">
									<el-form-item :label="$t('website.blog.subject')" prop="subject">
									    <el-input v-model="formData.subject"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="24">
								    <el-form-item :label="$t('website.blog.thumb')" prop="thumb">
									    <el-upload
										  :action="uploadUrl"
										  list-type="picture-card"
										  :before-upload="checkUpload"
										  :on-preview="handlePictureCardPreview"
										  :on-remove="handleRemove"
										  :on-success="handlePicture"
										  :limit="1">
										  <i class="el-icon-plus"></i>
										</el-upload>
										<el-dialog :visible.sync="dialogVisible">
										  <img width="100%" :src="dialogImageUrl" alt="">
										</el-dialog>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item :label="$t('website.blog.category')" prop="category">
										<el-select v-model="formData.category" 
									    :placeholder="$t('ap.le-ph')" style="width:100%">
										    <el-option
										      v-for="item in blogCategory"
										      :key="item.id"
										      :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
										      :value="item.id">
										    </el-option>
										  </el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item :label="$t('website.blog.post-date')" prop="postDate">
									    <el-date-picker
									      v-model="formData.postDate"
									      type="date"
									      :placeholder="$t('ap.pay-ph')"
									      style="width:100%"
									      format="yyyy-MM-dd">
									    </el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item :label="$t('website.blog.author')" prop="authorId">
										<el-autocomplete
										      class="inline-input"
										      v-model="formData.author"
										      :fetch-suggestions="querySearchUser"
										      :placeholder="$t('website.blog.author-ph')"
										      @select="handleSelectUser"
										      style="width:100%"
										      :clearable="true"
										    ></el-autocomplete>
									</el-form-item>
								</el-col>
								<el-col :span="24">
								  <el-form-item prop="content">
									<quill-editor v-model="formData.content" ref="myQuillEditor" class="editer" :options="editorOption" @ready="onEditorReady($event)"
										>
	              					</quill-editor>
	              				  </el-form-item>
								</el-col>

							</el-row>
						</div>
					</div>
					<div class="text-center">
						<el-button type="primary" style="width:100%" @click.prevent="createBlog">{{ $t('website.blog.submit') }}</el-button>
					</div>
				</div>
				</el-form>
			</div>
		</div>
	</div>
</template>
<style>
	.edit_container {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 20px;
    }
    .ql-editor{
       height:700px;
    }
	.ql-snow .ql-editor img {
	  max-width: 480px;
	}
	.ql-editor .ql-video {
	  max-width: 480px;
	}
</style>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'BlogForm',
  data: function() {
	return {
	  formData: {
        'id': null,
        'subject': null,
        'content': null,
        'postDate': moment().format('YYYY-MM-DD'),
        'author': null,
        'authorId': null,
        'category': null,
        'thumb': null,
        'path': null,
        'filename': null
      },
      formRules: {
	    'subject': [{required: true, message: this.$t('website.blog.validate.subject'), trigger: 'blur'}],
	    'content': [{required: true, message: this.$t('website.blog.validate.content'), trigger: 'blur'}],
	    'thumb': [{required: true, message: this.$t('website.blog.validate.thumb'), trigger: ['blur', 'change']}],
	    'category': [{required: true, message: this.$t('website.blog.validate.category'), trigger: ['blur', 'change']}],
	    'postDate': [{required: true, message: this.$t('website.blog.validate.post-date'), trigger: 'blur'}],
	    'authorId': [{required: true, message: this.$t('website.blog.validate.author'), trigger: 'blur'}]
      },
      editorOption: {

      },
      users: [],
      dialogImageUrl: '',
      dialogVisible: false
	}
  },
  watch: {
    
  },
  computed: {
    uploadUrl: function() {
      return this.API3_PREFIX + 'upload'
    },
    isEdit: function() {
      return this.formData.id > 0
    }
  },
  methods: {
    checkUpload: function(file) {
      let allowedExt = ['jpg', 'jpeg', 'png'],
          name = file.name.split('.'),
          that = this
      if (allowedExt.indexOf(name[name.length - 1]) === -1) {
        this.$message({
          message: this.$t('website.blog.upload-file-type'),
          type: 'error'
        })
        return false
      }
      if (file.size / 1024 / 1024 > 3) {
        this.$message({
          message: this.$t('website.blog.upload-file-size'),
          type: 'error'
        })
        return false
      }
      return true
    },
    handlePicture: function(response, file, fileList) {
      //console.log(response)
      //console.log(file)
      this.formData.filename = response.filename
      this.formData.path = response.path
      this.formData.thumb = response.path + '/' + response.filename
    },
    uploadError: function(err, file, fileList) {
      this.$message({
          message: this.$t('website.blog.upload-err'),
          type: 'error'
        })
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.formData.filename = null
      this.formData.path = null
      this.formData.thumb = null
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onEditorReady: function(editor) {
   	},
   	querySearchUser: function(queryString, cb) {
    	//get users api/suggest/user
    	let that = this,
    		query = '?filter%5Bname%5D=' + encodeURI(queryString) + 
    		'&filter%5Bgroup%5D=true&results_per_page=20&_=' + Date.parse(new Date())

    	this.$http.get(this.API_PREFIX + '/api/suggest/user' + query).then(function (response) {
			that.users = response.data.hits
			that.users.forEach(function(user, i) {
		      user.value = user.data.nickname
			})
			//console.log(that.users)
			cb(that.users)
		}).catch(function (error) {
			console.log(error)
		})
    },
    handleSelectUser: function(item) {
      this.formData.authorId = item.data.id
    },
    createBlog: function() {
      console.log(this.formData)
      
      this.$refs.form.validate(valid => {
        if (valid) {
          let that = this,
              loading = Loading.service({ fullscreen: true })
          this.formData.userId = localStorage.getItem('token')
          if (this.isEdit) {
	          // create new
		      this.$http.put(this.API3_PREFIX + 'blog', this.formData).then(function (response) {
	              that.$nextTick(() => {
	                loading.close();
	              })
	              that.$message({
	                message: that.$t('website.blog.success'),
	                type: 'success'
	              })
	              that.$router.push({
	                path: '/blog'
	              })
              }).catch(function (error) {
	              console.log(error)
	         // create new
		           that.$nextTick(() => {
	                loading.close();
	              })
	              that.$message({
	                message: that.$t('website.blog.failed'),
	                type: 'error'
	              })
              })
		   } else {
		      this.$http.post(this.API3_PREFIX + 'blog', this.formData).then(function (response) {
	              that.$nextTick(() => {
	                loading.close();
	              })
	              that.$message({
	                message: that.$t('website.blog.success'),
	                type: 'success'
	              })
	              that.$router.push({
	                path: '/blog'
	              })
              }).catch(function (error) {
	              console.log(error)
	              that.$nextTick(() => {
	                loading.close();
	              })
	              that.$message({
	                message: that.$t('website.blog.failed'),
	                type: 'error'
	              })
              })
		   }
	      
        } else {
          // do stuff if not valid.
          this.$message({
	          message: this.$t('website.blog.invalid'),
	          type: 'error'
	        })
          return false
        }
      })
      
    }
  },
  created: function() {
    let bid = this.$route.params.id,
    	that = this
      this.$http.get(this.API3_PREFIX + 'blog/' + bid).then(function (response) {
        that.formData = response.data
      }).catch(function (error) {
        console.log(error)
      })
  }
}
</script>